import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {map, takeUntil} from 'rxjs/operators';
import {Router} from '@angular/router';
import {FilterModel, PRIVILEGES, PropertyQuery, TableComponent} from 'common-shared';
import {PropertyService} from '../../../properties/property.service';
import {UnitService} from '../../units/unit.service';
import {ClassificatorValuesQuery} from 'common-shared';
import {ClassificatorsQuery} from 'common-shared';
import {BehaviorSubject, combineLatest, Observable} from "rxjs";
import {StateService} from "../../../core/services/state.service";
import {Table} from "primeng/table";
import {saveAs} from 'file-saver';
import {ExcelDataTransferService} from "../../excel-data-transfer.service";

@Component({
  selector: 'mes-web-property-list',
  templateUrl: './property-list.component.html'
})
export class PropertyListComponent extends TableComponent implements OnInit {
  filter$: BehaviorSubject<FilterModel<PropertyQuery>> = new BehaviorSubject<FilterModel<PropertyQuery>>(new FilterModel<PropertyQuery>());
  properties$: Observable<PropertyQuery[]>;
  @ViewChild(Table) table: Table;
  protected readonly PRIVILEGES = PRIVILEGES;

  constructor(private router: Router, private propertyService: PropertyService, public classificatorValuesQuery: ClassificatorValuesQuery, public classificatorsQuery: ClassificatorsQuery, public unitService: UnitService, private state: StateService, private changeDetector: ChangeDetectorRef, private excelDataTransferService: ExcelDataTransferService) {
    super();
  }

  ngOnInit() {
    this.restoreFilterState();
  }

  ngAfterViewInit() {
    this.changeDetector.detach();
    this.configureFilter();
    this.changeDetector.detectChanges();
    this.changeDetector.reattach();
  }

  private restoreFilterState() {
    const filterState = this.state.getFilterState<PropertyQuery>() ?? new FilterModel<PropertyQuery>({Data: new PropertyQuery()});
    this.filter$.next(filterState);
  }

  configureFilter(): void {
    this.properties$ = combineLatest(
      [this.propertyService.getAll$, this.filter$]
    ).pipe(map(([properties, filter]) => {
      if (this.table) {
        this.table.first = 0;
      }

      this.state.setFilterState(filter);
      this.table?.filterGlobal(filter.Global, 'contains');
      this.table?.filter(filter.Data.GroupClv, 'GroupClv', 'equals');
      this.table?.filter(filter.Data.TypeClv, 'TypeClv', 'equals');
      this.table?.filter(filter.Data.ChoiceTypeClassificatorId, 'ChoiceTypeClassificatorId', 'equals');
      this.table?.filter(filter.Data.UnitId, 'UnitId', 'equals');
      return properties;
    }));
  }

  add() {
    this.router.navigate(['./common/property/add']).catch(reason => console.error(reason));
  }

  downloadExcel() {
    return this.excelDataTransferService.downloadSpecs(this.table.filteredValue?.map(value => value.Id)).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      saveAs(value.data, value.fileName);
    });
  }
}
